import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import goodPhotos from 'assets/images/unlimitedCard/goodPhotos.png'
import badPhotos from 'assets/images/unlimitedCard/badPhotos.png'
import { Wrapper } from './styles'
import { FormattedMessage } from 'react-intl'

const Examples = () => (
    <Wrapper direction="column" gap={[16, 24]} pl={[0, 48]} mt={[24, 0]}>
        <Box gap={16}>
            <Text variant="bodyStrong" color="grayscale_900" ml={8}>
                <FormattedMessage
                    id="annual.add_photo_examples.subtitle_correct"
                    defaultMessage="Przykłady <span>dobrych</span> zdjęć:"
                    description="Keep the html tags in the translation"
                    values={{
                        span: (chunks: string[]) => (
                            <Text
                                as="span"
                                variant="bodyStrong"
                                color="success"
                            >
                                {chunks}
                            </Text>
                        ),
                    }}
                />
            </Text>
            <img src={goodPhotos} alt="examples of correct photos" />
        </Box>
        <Box gap={16}>
            <Text variant="bodyStrong" color="grayscale_900" ml={8}>
                <FormattedMessage
                    id="annual.add_photo_examples.subtitle_incorrect"
                    defaultMessage="Przykłady <span>złych</span> zdjęć:"
                    description="Keep the html tags in the translation"
                    values={{
                        span: (chunks: string[]) => (
                            <Text as="span" variant="bodyStrong" color="error">
                                {chunks}
                            </Text>
                        ),
                    }}
                />
            </Text>
            <img src={badPhotos} alt="examples of incorrect photos" />
        </Box>
    </Wrapper>
)

export default Examples
